//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

export enum SessionMode {
  Client = 'CLIENT_MODE',
  Moderator = 'MODERATOR_MODE',
}
